export class ComparableDataExclusion {
  value: string;
}
